// client/src/features/auth/authApiSlice.js
import { apiSlice } from "../../app/api/apiSlice"
import { logOut, setCredentials } from "./authSlice"

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/auth',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        googleLogin: builder.mutation({
            // id_token is the one returned by Google’s popup
            query: id_token => ({
                url: '/auth/google',
                method: 'POST',
                body: { id_token }           // { id_token: "eyJhbGciOi..." }
            }),
            async onQueryStarted(id_token, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    const { accessToken } = data;
                    dispatch(setCredentials({ accessToken }));
                } catch (err) {
                    console.error('Google login failed:', err);
                }
            }
        }),
        microsoftLogin: builder.mutation({
            query: ({ id_token }) => ({
                url: "/auth/microsoft",
                method: "POST",
                body: { id_token },
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(setCredentials({ accessToken: data.accessToken }));
                } catch (err) {
                    console.error("Microsoft login failed:", err);
                }
            },
        }),
        sendLogout: builder.mutation({
            query: () => ({
                url: '/auth/logout',
                method: 'POST',
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    console.log(data)
                    dispatch(logOut())
                    setTimeout(() => {
                        dispatch(apiSlice.util.resetApiState())
                    }, 1000)
                } catch (err) {
                    console.log(err)
                }
            }
        }),
        refresh: builder.mutation({
            query: () => ({
                url: '/auth/refresh',
                method: 'GET',
            }),
        }),
    })
})

export const {
    useLoginMutation,
    useGoogleLoginMutation,
    useMicrosoftLoginMutation,
    useSendLogoutMutation,
    useRefreshMutation,
} = authApiSlice 